import { ReceivingReportRecord } from '../../../../types/ReceivingReport';
import { RecordFile } from '../../../../types';
import React from 'react';
import AttachmentUpload from '../../../../components/AttachmentUpload';
import ReceivingReportInfoView from './ReceivingReportInfoView';
import ReceivingReportInfoTabs from './ReceivingReportInfoTabs';

interface ReceivingReportInfoContentProps {
  data?: ReceivingReportRecord;
  attachments?: RecordFile[];
  /** Set together to allow adding/removing; omit any and the list stays read-only. */
  api?: string;
  recordId?: string;
  canEdit?: boolean;
}
const ReceivingReportInfoContent: React.FC<ReceivingReportInfoContentProps> = ({
  data,
  attachments,
  api,
  recordId,
  canEdit,
}) => {
  return (
    <>
      <div className={'w-9/12 space-y-4 h-[calc(84vh)] overflow-auto m'}>
        <div className={'p-4 rounded'}>
          <ReceivingReportInfoView data={data} />
          <AttachmentUpload
          attachments={attachments}
          api={api}
          recordId={recordId}
          canEdit={canEdit}
        />
          {/*<ReceivingReportInfoTable rrMovements={data?.movements} />*/}
          <ReceivingReportInfoTabs data={data} />
        </div>
      </div>
    </>
  );
};

export default ReceivingReportInfoContent;
